import { IInputsProgress, IInputStatus, IStepProgress, IStepsProgress, IStepStatus, IViewStatus } from '../../../interface/progress.interface'
import { IProgressSettings, IStep } from '../../../interface/steps.interface'

const baseProgress = (
  steps: string[][],
  stepsSettings: any,
  inputs: any,
  values: any,
  // increaseProgress: Function,
  currentStepNumber: number,
  isOptions: string[]
) => {
  console.log('baseProgress')
  let currentPercent = 5
  console.log(stepsSettings)
  const stepsProgress: IStepsProgress = {}
  const progressSettings: IProgressSettings[] = []
  steps.forEach((step, index) => {

    const stepProgress: IStepProgress = {
      status: IStepStatus.none,
      viewStatus: IViewStatus.none,
      inputs: {},
      percent: stepsSettings[index]?.percent || null,
      title: stepsSettings[index]?.title
    }
    const inputsProgress: IInputsProgress = {}

    // if (index === currentStepNumber) {
    //   stepProgress.status = IStepStatus.current
    //   stepProgress.viewStatus = IViewStatus.current
    // } 
    let isFull = true
    try {
      step.forEach(name => {
        if (inputs[name]?.dependencies) {
          if (inputs[name].type === 'string') {
            inputsProgress[name] = {
              status: IInputStatus.notActive,
              percent: inputs[name]?.percent || null
            }
          } else {
            inputsProgress[name] = {
              status: IInputStatus.disabled,
              percent: inputs[name]?.percent || null
            }
          }
        } else if (values[name]) {
          inputsProgress[name] = {
            status: IInputStatus.success,
            percent: inputs[name]?.percent || null
          }
          if (inputs[name]?.percent) {
            currentPercent = increaseProgress(currentPercent, inputs[name].percent)
          }
        } else if (isOptions.indexOf(name) !== -1) {
          inputsProgress[name] = {
            status: IInputStatus.isOptions,
            percent: inputs[name]?.percent || null
          }
        } else {
  
          inputsProgress[name] = {
            status: IInputStatus.none,
            percent: inputs[name]?.percent || null
          }
          isFull = false
        }
      })
    } catch (error) {
      console.log(error)
    }
    console.log('baseProgress')

    if (index === currentStepNumber) {
      stepProgress.status = IStepStatus.current
      stepProgress.viewStatus = IViewStatus.current
    } else if (index < currentStepNumber) {
      console.log('stepProgress--->', index, currentStepNumber)
      stepProgress.status = IStepStatus.success
      stepProgress.viewStatus = IViewStatus.check
      currentPercent = increaseProgress(currentPercent, stepProgress.percent)
    }

    stepProgress.inputs = inputsProgress
    stepsProgress[index] = stepProgress
    console.log('stepsProgress--->', stepsProgress)
    //@ts-ignore
    progressSettings.push(stepsSettings[index]?.progress)
  })
  console.log('stepsProgress full--->', stepsProgress)
  return {
    stepsProgress,
    progressSettings,
    currentPercent
  }
}

function increaseProgress (currentPercent: number, percent: number | null) {
  if (percent) {
    const newPercent = currentPercent + percent
    if (newPercent >= 0 && newPercent <= 100) {
      return newPercent
    }
  } 
  return currentPercent

}

export default baseProgress